import { Box, Button } from "@mui/material";
import { FC } from "react";
import { ReceiptModeEnum } from "../list";

interface ReiceptToggleViewProps {
  mode: ReceiptModeEnum;
  setMode: (mode: ReceiptModeEnum) => void;
}
export const ReiceptToggleView: FC<ReiceptToggleViewProps> = ({
  mode,
  setMode,
}) => {
  return (
    <Box sx={{ display: "flex", alignSelf: "flex-end" }}>
      <Box className="mask-box">
        <Box
          className="mask"
          style={{
            transform: `translateX(${
              mode === ReceiptModeEnum.calendar ? 0 : "100px"
            })`,
          }}
        />
        <Button
          disableRipple
          variant="text"
          sx={{
            color: mode === ReceiptModeEnum.calendar ? "#ffffff" : "black",
          }}
          onClick={() => setMode(ReceiptModeEnum.calendar)}
        >
          Calendar
        </Button>
        <Button
          disableRipple
          variant="text"
          sx={{
            color: mode === ReceiptModeEnum.list ? "#ffffff" : "black",
          }}
          onClick={() => setMode(ReceiptModeEnum.list)}
        >
          List
        </Button>
      </Box>
    </Box>
  );
};
